import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { LandingPageGuest } from "./landing-page-guest";
import { LandingPageUser } from "./landing-page-user";
interface LandingProps {}

export const LandingPage = (props: LandingProps) => {
  const { isUserAuthenticated } = useAuthContext();

  return isUserAuthenticated ? <LandingPageUser /> : <LandingPageUser />;
};
